import png from './images/west_tigers.png'

export const colors = {
  dominant: '#f68b1f',
  highlight: '#fff',
}
export const fullname = 'West Tigers'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/tigers.js